import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../shared/icon/icon.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from "../shared/shared.module";
import { MenuModule } from 'headlessui-angular';

// moduleId: module.id,
@Component({
    templateUrl: './profile.html',
    standalone: true,
    imports: [CommonModule, IconModule, RouterModule, SharedModule, MenuModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProfileComponent {
    constructor() {}
}
